import React from 'react';
import ReactDOM from 'react-dom';
import App from 'app/main/App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import store from "app/main/store";
import {ThemeProvider} from '@material-ui/core/styles';
import responsiveFontSizes from "@material-ui/core/styles/responsiveFontSizes";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import OAuth2Service from 'app/services/OAuth2.service';
import config, {LOCAL_STORAGE_PREFIX} from './_helpers/app.constants';
// Hot Module Replacement
declare let module: { hot: any };


function render(AppVal: any) {
    let muiTheme = createMuiTheme();
    muiTheme = responsiveFontSizes(muiTheme);

    ReactDOM.render(
        <React.StrictMode>
            <div className={'appIndex'}>
                <ThemeProvider theme={muiTheme}>
                    <Provider store={store}>

                        <AppVal/>
                    </Provider>
                </ThemeProvider>

            </div>
        </React.StrictMode>,
        document.getElementById('root')
    );
}

OAuth2Service.init(config.oauth2, (key: string) => JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_PREFIX}${key}`)),
  (key: string, value: string) => localStorage.setItem(`${LOCAL_STORAGE_PREFIX}${key}`, JSON.stringify(value)),
  (key: string) => localStorage.removeItem(`${LOCAL_STORAGE_PREFIX}${key}`),
  LOCAL_STORAGE_PREFIX);
render(App);
if (module.hot) {
    module.hot.accept("app/main/App", () => {
        const App = require("app/main/App").default;
        render(App);
    });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
